// src/lib/compta-resultat.js — LA formule du résultat net mensuel FBZ.
//
// POURQUOI ce fichier existe (correctif 2026-08-05) : l'écran Compta calculait
// ce résultat DEUX FOIS, à deux endroits, avec deux formules différentes —
//   • le grand chiffre « Résultat net » du bandeau comptait les commissions, la
//     marge ménage, le bénéfice de SOUS-LOCATION et la charge des INCIDENTS ;
//   • la barre du graphe annuel, elle, oubliait la sous-location ET les
//     incidents.
// Le même écran affichait donc deux résultats différents pour le même mois.
//
// La formule vit désormais ICI, en un seul exemplaire, et les deux affichages
// l'appellent. Une composante oubliée d'un côté n'est plus possible : il
// faudrait la retirer de la seule et unique formule.

/**
 * Résultat net FBZ d'un mois.
 *
 * Convention : le ménage est un flux TRANSITOIRE (encaissé pour le compte du
 * prestataire) — seule la MARGE ménage, quand un forfait est configuré, est un
 * revenu. Le CA de sous-location n'entre pas brut : c'est son BÉNÉFICE
 * (CA − loyer − charges variables) qui est un revenu FBZ.
 *
 * @param {object} p
 * @param {number} p.commissions    — Σ commissions conciergerie du mois
 * @param {number} p.margeMenage    — Σ marges ménage (0 si aucun forfait)
 * @param {number} p.sousLocNet     — Σ bénéfices sous-location (peut être négatif)
 * @param {number} p.chargesFixes   — charges fixes récurrentes
 * @param {number} p.depensesVar    — dépenses variables du mois
 * @param {number} p.consommables   — coût des dépôts consommables du mois
 * @param {number} p.incidentsNet   — charge nette des incidents « Achat FULLBNBZEN »
 * @returns {number}
 */
export function computeResultatNetMois({
  commissions = 0,
  margeMenage = 0,
  sousLocNet = 0,
  chargesFixes = 0,
  depensesVar = 0,
  consommables = 0,
  incidentsNet = 0,
} = {}) {
  const n = v => (Number.isFinite(Number(v)) ? Number(v) : 0)
  return (
    n(commissions) + n(margeMenage) + n(sousLocNet)
    - n(chargesFixes) - n(depensesVar) - n(consommables) - n(incidentsNet)
  )
}
